import _ from 'lodash';
import template from './shema.html';

class ShemaController {
    constructor() {

    }

    $onInit() {
        this.pozicije = [];
        this.veze = [];
        this.nalog.stavke.forEach((stavka) => {
            this.pozicije.push({broj: stavka.pozicija, selected:true, veza:false});
        });
        this.nalog.veze.forEach((veza) => {
            const pozicija = veza.pozicija.toString();
            this.veze.push({broj: parseInt(pozicija.slice(0,2)), selected:true, veza: true});
            this.veze.push({broj: parseInt(pozicija.slice(2,4)), selected:true, veza: true});
        });
    }


    pozSelected(poz) {
        return _.filter(this.pozicije, (item) => {
                return item.broj === poz;
        }).length > 0;
    }

    vezaSelected(poz) {
        return _.filter(this.veze, (item) => {
                return item.broj === poz;
        }).length > 0;
    }
}

ShemaController.$inject = [];

const ShemaComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: ShemaController,
    controllerAs: 'vm',
    bindings:{
        nalog: '<'
    }
};

export {ShemaComponent};
export {ShemaController};



// WEBPACK FOOTER //
// ./app/components/radniNalog/shema.component.js